'use client';

import { c as _c } from "react/compiler-runtime";
import { useRegisterQueryErrorHandler } from '@module/queries';
import { useLoginMustHandler } from '@module/queries/useLoginMustHandler';
import ToastBody from '@pc/components/atoms/toast/ToastBody';
import { type Toast, toast } from 'react-hot-toast';

// 동시에 여러 toastError가 터져도 토스트가 줄줄이 쌓이지 않도록 고정 id로 하나만 띄운다(마지막 메시지로 갱신).
const TOAST_ERROR_ID = 'query-toast-error';

/**
 * pandatv-pc의 쿼리 에러 정책 등록부(자기 switch를 소유).
 * 공통 정책(loginMust)은 공용 훅을 조립해 쓰고, 앱-고유 정책(toastError → 자기 ToastBody 토스트)은 여기에 둔다.
 */
export function QueryErrorBridge() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      confirmText: "\uD655\uC778"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleLoginMust = useLoginMustHandler(t0);
  let t1;
  if ($[1] !== handleLoginMust) {
    t1 = (errorCode, error) => {
      bb2: switch (errorCode) {
        case "loginMust":
          {
            handleLoginMust(error);
            break bb2;
          }
        case "toastError":
          {
            toast(t => <ToastBody id={t.id} content={error.serverResponse.message} />, {
              id: TOAST_ERROR_ID
            });
          }
      }
    };
    $[1] = handleLoginMust;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useRegisterQueryErrorHandler(t1);
  return null;
}